import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, TransitionOptions, Transitions } from "../../types"

export const baseTransition = <T = any>(
  id: string,
  serviceCall: string,
  returnTarget = "idle",
  options?: TransitionOptions<T>
): StateNodeConfig<Context, {}, Transitions, BaseActionObject> => {
  const {
    loadingState,
    onSuccess,
    onError,
    successActions = [],
    errorActions = []
  } = options

  return {
    entry:
      loadingState &&
      assign<Context>(ctx => ({
        loading: { ...ctx.loading, [loadingState]: true }
      })),
    exit:
      loadingState &&
      assign<Context>(ctx => ({
        loading: { ...ctx.loading, [loadingState]: false }
      })),
    invoke: {
      id: id,
      src: serviceCall,
      onDone: {
        target: returnTarget,
        actions: [
          onSuccess && assign<Context, DoneInvokeEvent<T>>(onSuccess),
          ...successActions
        ]
      },
      onError: {
        target: returnTarget,
        actions: [
          onError && assign<Context, DoneInvokeEvent<any>>(onError),
          ...errorActions
        ]
      }
    }
  }
}
